import axios from 'axios';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

/**
 * Mounted on the same field-view service as Attendance/Advances (see
 * attendanceService.js) at /pollination (field-view/routes/index.js:
 * app.use("/pollination", pollination_routes)). Same auth convention:
 * source: humblebee_admin + bearer token.
 */
const authHeaders = () => ({
  'Content-Type': 'application/json',
  source: 'humblebee_admin',
  Authorization: `Bearer ${cookies.get('access_token')}`,
});

const FIELD_API = () => process.env.REACT_APP_API_APP_FIELD_URL;

export const createPollinationProject = async (payload) => {
  const res = await axios.post(`${FIELD_API()}/pollination/projects`, payload, { headers: authHeaders() });
  return res.data;
};

export const getPollinationProjects = async () => {
  try {
    const res = await axios.get(`${FIELD_API()}/pollination/projects`, { headers: authHeaders() });
    return res.data?.projects || [];
  } catch (error) {
    console.error('Error fetching pollination projects:', error);
    return [];
  }
};

export const getPollinationProject = async (projectId) => {
  const res = await axios.get(`${FIELD_API()}/pollination/projects/${projectId}`, { headers: authHeaders() });
  return res.data?.project;
};

export const updatePollinationProject = async (projectId, payload) => {
  const res = await axios.patch(`${FIELD_API()}/pollination/projects/${projectId}`, payload, { headers: authHeaders() });
  return res.data;
};

export const getPollinationProjectFarmers = async (projectId) => {
  try {
    const res = await axios.get(`${FIELD_API()}/pollination/projects/${projectId}/farmers`, { headers: authHeaders() });
    return res.data?.farmers || [];
  } catch (error) {
    console.error('Error fetching pollination farmers:', error);
    return [];
  }
};

// Same bundled endpoint the mobile Farmer Hub screen uses (farmer + all 4
// stages in one call) — reused here instead of 4 separate web-side fetches.
export const getPollinationFarmerHub = async (farmerId) => {
  const res = await axios.get(`${FIELD_API()}/pollination/farmers/${farmerId}`, { headers: authHeaders() });
  return res.data;
};

// getPollinationFarmerHub only returns the latest deployment/observation —
// these two give the full history, same endpoints the mobile app's list
// screens now use.
export const getPollinationDeployments = async (farmerId) => {
  try {
    const res = await axios.get(`${FIELD_API()}/pollination/farmers/${farmerId}/deployments`, { headers: authHeaders() });
    return res.data?.deployments || [];
  } catch (error) {
    console.error('Error fetching pollination deployments:', error);
    return [];
  }
};

export const getPollinationObservations = async (farmerId) => {
  try {
    const res = await axios.get(`${FIELD_API()}/pollination/farmers/${farmerId}/observations`, { headers: authHeaders() });
    return res.data?.observations || [];
  } catch (error) {
    console.error('Error fetching pollination observations:', error);
    return [];
  }
};
